export default "varying vec3 vPos;\n\nvoid main() {\n    vPos = position;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"